import React, {createContext, useContext} from 'react';

interface SubdomainProxyContext {
  isProxied: boolean;
  hasDroppedMobileSubdomain: boolean;
}

const context = createContext<SubdomainProxyContext | null>(null);

export const SubdomainProxyProvider: React.FC<
  React.PropsWithChildren<SubdomainProxyContext>
> = ({children, isProxied, hasDroppedMobileSubdomain}) => {
  return (
    <context.Provider value={{isProxied, hasDroppedMobileSubdomain}}>
      {children}
    </context.Provider>
  );
};

const useContextValue = (): SubdomainProxyContext => {
  const value = useContext(context);

  if (!value) {
    throw new Error('SubdomainProxyProvider not found in context');
  }

  return value;
};

export const useIsProxied = () => useContextValue().isProxied;
export const useHasDroppedMobileSubdomain = () =>
  useContextValue().hasDroppedMobileSubdomain;
